module.exports = __webpack_public_path__ + "media/images/facebook-d909d8a539c2d9a49994d500b75802e4.svg";